import { defineCustomElement } from 'vue'
import SpielplanWidget from './SpielplanWidget.vue'
import StartseiteWidget from './StartseiteWidget.vue'
import RankingList from './components/RundenRanking.vue'
import BetmanStoryWidget from './components/Betmanstorywidget.vue'
import RankingListTv from './components/TvRangliste.vue'
import LiveTickerWidget from './LiveTickerWidget.vue'
import OverlayHost from './OverlayHost.vue'
import styles from './style.css?inline'

const TmSpielplan = defineCustomElement({
  ...SpielplanWidget,
  styles: [styles] // wird ins Shadow DOM injiziert -> keine Kollision mit bestehendem jQuery/CSS
})

customElements.define('tm-spielplan', TmSpielplan)



const TmStartseite = defineCustomElement({
  ...StartseiteWidget,
  styles: [styles] // dieselbe Stylesheet-Datei - die ts-*-Klassen stehen unten mit drin
})
 
customElements.define('tm-startseite', TmStartseite)


// 1. Die Vue-Komponente in ein Web Component umwandeln
const TmRangliste = defineCustomElement(RankingList)

// 2. Dem Browser den HTML-Tag-Namen beibringen
// (Wichtig: Custom Elements MÜSSEN laut Spezifikation immer einen Bindestrich "-" enthalten!)
if (!customElements.get('tm-rangliste')) {
  customElements.define('tm-rangliste', TmRangliste)
}


// 1. Die Vue-Komponente in ein Web Component umwandeln
const TvRanking = defineCustomElement(RankingListTv)

// 2. Dem Browser den HTML-Tag-Namen beibringen
// (Wichtig: Custom Elements MÜSSEN laut Spezifikation immer einen Bindestrich "-" enthalten!)
if (!customElements.get('tm-rangliste-tv')) {
  customElements.define('tm-rangliste-tv', TvRanking)
}


const TmBetmanStoryWidget = defineCustomElement({
  ...BetmanStoryWidget,
  styles: [styles]
})
customElements.define('tm-betman-story-widget', TmBetmanStoryWidget)


// Eigenständiges, unsichtbares Element - lauscht auf window-Events (siehe OverlayHost.vue) und
// öffnet dann unser DetailOverlay, unabhängig von allen anderen Widget-Instanzen auf der Seite.
// Für Stellen wie die Tipp-Cards (reines Host-Seiten-HTML/JS), die kein eigenes unserer Widgets
// sind, aber trotzdem per matchId unser reichhaltiges Match-Detail-Overlay öffnen sollen.
// WICHTIG: Styles hier ebenfalls injizieren (wie bei TmSpielplan/TmStartseite) - DetailOverlay
// braucht dieselben .tm-detail-overlay/.tm-sheet-backdrop-Klassen aus der gemeinsamen style.css.
const TmOverlayHost = defineCustomElement({
  ...OverlayHost,
  styles: [styles]
})
customElements.define('tm-overlay-host', TmOverlayHost)


const TmLiveTicker = defineCustomElement({
  ...LiveTickerWidget,
  styles: [styles]
})
customElements.define('tm-liveticker', TmLiveTicker)